export class Instance {
    Id: number;
    Name: string;
    Url: string;
    PasswordKey: string;
    UserNameKey: string;
    TimeZone: string;
    Selected: boolean;
    QtyEnable: boolean;
}
